// Canonical realtime contract. Legacy names are receive-only aliases while the
// API rollout is in progress; clients always join with JOIN_MATCH.
export const SOCKET_EVENTS = Object.freeze({
  JOIN_MATCH: "join-match",
  LEAVE_MATCH: "leave-match",
  RESYNC: "MATCH_RESYNC_REQUIRED",
  STATE_UPDATED: "MATCH_STATE_UPDATED",
  EVENT_CREATED: "MATCH_EVENT_CREATED",
  EVENT_UPDATED: "MATCH_EVENT_UPDATED",
  EVENT_DELETED: "MATCH_EVENT_DELETED",
  TIMER_UPDATED: "MATCH_TIMER_UPDATED",
  SCORE_UPDATED: "MATCH_SCORE_UPDATED",
  LINEUP_UPDATED: "MATCH_LINEUP_UPDATED",
  STATUS_UPDATED: "MATCH_STATUS_UPDATED",
});

export default SOCKET_EVENTS;
